import { useEffect, useState } from "react";
import { getAxios } from "@coremind/identity-core";
// Module-level cache -- every page that groups sites by vertical (HomePage's gallery, /pricing,
// /docs, /status, each /<vertical> page) calls this hook independently; the catalog itself is
// the same for the whole session, so there's no reason for each to issue its own request.
let cache = null;
let inflight = null;
function fetchCatalog() {
    if (cache)
        return Promise.resolve(cache);
    if (!inflight) {
        inflight = getAxios()
            .get("/platform/sites/public/catalog")
            .then((res) => {
            cache = res.data ?? [];
            return cache;
        })
            .catch(() => {
            cache = [];
            return cache;
        })
            .finally(() => {
            inflight = null;
        });
    }
    return inflight;
}
/**
 * Real, backend-driven replacement for www's old static verticals.ts PLATFORM_SITES array.
 * Calls GET /api/v1/platform/sites/public/catalog (unauthenticated -- these are marketing pages),
 * backed by core.platform_sites.settings.catalog.
 */
export function usePlatformSiteCatalog() {
    const [sites, setSites] = useState(cache ?? []);
    const [loading, setLoading] = useState(!cache);
    useEffect(() => {
        if (cache) {
            setSites(cache);
            setLoading(false);
            return;
        }
        let cancelled = false;
        fetchCatalog().then((data) => {
            if (!cancelled) {
                setSites(data);
                setLoading(false);
            }
        });
        return () => {
            cancelled = true;
        };
    }, []);
    return { sites, loading };
}
